class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    // TL: Support bundled add-to-cart so notification can show all newly added items.
    this.addedItemKeys = Array.isArray(parsedState.addedItemKeys) ? parsedState.addedItemKeys : [this.cartItemKey];
    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-notification-product') {
        document.getElementById(section.id).innerHTML = this.getAddedItemsInnerHTML(parsedState.sections[section.id]);
      } else {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  // TL: Render one card per recently added line item in cart-notification.
  getAddedItemsInnerHTML(html) {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const uniqueKeys = [...new Set(this.addedItemKeys.filter(Boolean))];
    const cards = uniqueKeys
      .map((itemKey) => doc.querySelector(`[id="cart-notification-product-${itemKey}"]`))
      .filter(Boolean);

    if (cards.length === 0 && this.cartItemKey) {
      const fallback = doc.querySelector(`[id="cart-notification-product-${this.cartItemKey}"]`);
      return fallback ? fallback.outerHTML : '';
    }

    return cards.map((card) => card.outerHTML).join('');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
